<!-- 共通フッター -->
<template>
  <footer class="siteFooter">
    <p>免税システム スマートデタックス</p>
    <p>サポートコールセンター 050-8882-6886</p>
  </footer>
</template>
<script>
export default {
};
</script>
